import React, { useState } from "react";
import axios from "axios";
import { API, colors } from "../shared/constants";
import { styles } from "../shared/styles";
import { TabBar } from "../shared/TabBar";
import { BackButton } from "../shared/BackButton";
import { UnitFormModal, deleteTenant } from "./UnitFormModal";
import { UnitContactModal } from "./UnitContactModal";
import { FlatAssetRegister } from "./FlatAssetRegister";

export function UnitDetail({ unit, siteId, onBack }) {
  const [activeTab, setActiveTab] = useState("assets");
  const [showEdit, setShowEdit] = useState(false);
  const [showAddContact, setShowAddContact] = useState(false);
  const [currentUnit, setCurrentUnit] = useState(unit);

  const tabs = ["assets", "contacts"];
  const tabLabels = { contacts: "Contacts", assets: "Asset Register" };

  return (
    <div>
      <div style={styles.topbar}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <BackButton onClick={onBack} title="Units" />
          <div style={styles.pageTitle}>
            {currentUnit.unit_number || currentUnit.name || "Unnamed Unit"}
          </div>
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <button
            onClick={async () => {
              if (await deleteTenant(currentUnit)) onBack();
            }}
            style={{
              backgroundColor: "#f1f5f9", color: "#64748b", border: "none",
              padding: "6px 16px", borderRadius: "6px", fontSize: "13px",
              fontWeight: "600", cursor: "pointer",
            }}
          >
            Delete
          </button>
          <button onClick={() => setShowEdit(true)} style={{
            backgroundColor: colors.blue, color: "#fff", border: "none",
            padding: "6px 16px", borderRadius: "6px", fontSize: "13px",
            fontWeight: "600", cursor: "pointer",
          }}>
            Edit Unit
          </button>
        </div>
      </div>

      {currentUnit.notes && (
        <div style={{
          padding: "8px 24px", display: "flex", gap: "20px", flexWrap: "wrap",
          fontSize: "13px", color: "#666", borderBottom: `1px solid ${colors.border}`,
        }}>
          <div><strong style={{ color: colors.text }}>Notes:</strong> {currentUnit.notes}</div>
        </div>
      )}

      <TabBar tabs={tabs} tabLabels={tabLabels} activeTab={activeTab} onSelect={setActiveTab} />

      <div style={styles.content}>
        {activeTab === "contacts" && (
          <div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
              <button style={styles.addButton} onClick={() => setShowAddContact(true)}>
                + Add Contact
              </button>
            </div>
            <div style={styles.card}>
              {!currentUnit.contacts || currentUnit.contacts.length === 0 ? (
                <div style={styles.loading}>No contacts yet.</div>
              ) : (
                <>
                  <div style={{ ...styles.tableHeader, gridTemplateColumns: "2fr 1.5fr 1.5fr 2fr 1fr" }}>
                    <div>Name</div>
                    <div>Role</div>
                    <div>Phone / Mobile</div>
                    <div>Email</div>
                    <div>Reports</div>
                  </div>
                  {currentUnit.contacts.map((c) => (
                    <div key={c.id} style={{ ...styles.tableRow(false), gridTemplateColumns: "2fr 1.5fr 1.5fr 2fr 1fr" }}>
                      <div>
                        <div style={{ fontWeight: "500" }}>{c.name}</div>
                        {c.position && <div style={{ fontSize: "12px", color: "#999" }}>{c.position}</div>}
                      </div>
                      <div>{c.role.charAt(0).toUpperCase() + c.role.slice(1)}</div>
                      <div>
                        {c.phone && <div>{c.phone}</div>}
                        {c.mobile && <div style={{ fontSize: "12px", color: "#999" }}>{c.mobile}</div>}
                      </div>
                      <div style={{ fontSize: "13px" }}>{c.email}</div>
                      <div>
                        {c.receives_reports
                          ? <span style={{ color: "#27ae60", fontWeight: "600" }}>Yes</span>
                          : <span style={{ color: "#999" }}>No</span>}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        )}

        {activeTab === "assets" && (
          <FlatAssetRegister siteId={siteId} scopeType="unit" scopeId={unit.id}
            scopeLabel={unit.unit_number ? `Unit ${unit.unit_number}` : unit.name} />
        )}
      </div>

      {showEdit && (
        <UnitFormModal
          siteId={siteId}
          existingUnit={currentUnit}
          onClose={() => setShowEdit(false)}
          onSave={async () => {
            const res = await axios.get(`${API}/site-units/${unit.id}/`);
            setCurrentUnit(res.data);
            setShowEdit(false);
          }}
        />
      )}
      {showAddContact && (
        <UnitContactModal
          unitId={unit.id}
          onClose={() => setShowAddContact(false)}
          onSave={async () => {
            const res = await axios.get(`${API}/site-units/${unit.id}/`);
            setCurrentUnit(res.data);
          }}
        />
      )}
    </div>
  );
}
